import React, { useEffect, useState } from 'react';
import { tracking } from '@iwoca/frontend-tracking-library';
import { IconLink } from '@iwoca/icons';
import { Button } from '@iwoca/orion';
import { Trans } from '@lingui/macro';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import { getAmplitudeDefaultEventProperties } from 'utils/amplitudeEvents';
import styles from '../InviteModal.module.css';

interface Props {
  text: string;
}

export const InviteButton: React.FunctionComponent<Props> = (props: Props) => {
  const [hideCopied, setHideCopied] = useState(true);

  const copyLink = () => {
    setHideCopied(false);
    tracking.ampli.ctaClick({
      'CTA text': 'Copy invite link',
      ...getAmplitudeDefaultEventProperties(),
    });
  };

  useEffect(() => {
    const hideCopiedTimeout = setTimeout(() => setHideCopied(true), 2000);
    return () => {
      clearTimeout(hideCopiedTimeout);
    };
  }, [hideCopied]);

  return (
    <CopyToClipboard text={props.text} onCopy={() => copyLink()}>
      <Button variant="primary" size="small" className={styles.button}>
        {hideCopied ? (
          <>
            <Trans>Copy invite link</Trans>
            <IconLink className={styles.icon} />
          </>
        ) : (
          <Trans>The link was copied to your clipboard</Trans>
        )}
      </Button>
    </CopyToClipboard>
  );
};
